module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-technician-forklift-report/master-technician-forklift-report.component.scss
// module id = ./src/app/master/master-technician-forklift-report/master-technician-forklift-report.component.scss
// module chunks = main